import { useEffect, useState } from 'react';
import { hrApi } from '@/api';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Select } from '@/components/ui/Select';
import type { HrAttendanceDevice } from '@/types/hr';
import { showApiError } from '@/utils/apiError';
import { notify } from '@/core/toast/notify';
export function HrDevicesPage() {
  const [devices, setDevices] = useState<HrAttendanceDevice[]>([]);
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [type, setType] = useState('BIOMETRIC');

  const load = () => {
    hrApi.listDevices().then(setDevices).catch((err) => showApiError(err, 'Failed to load devices'));
  };

  useEffect(() => {
    load();
  }, []);

  const register = async () => {
    try {
      const device = await hrApi.registerDevice({ deviceName: name, deviceCode: code, deviceType: type });
      notify.success(`Device registered. API key: ${device.apiKey}`);
      setName('');
      setCode('');
      load();
    } catch (err) {
      showApiError(err, 'Registration failed');
    }
  };

  return (
    <div>
      <PageHeader
        title="Attendance devices"
        description="Biometric, RFID, QR, and face recognition connectors"
        breadcrumbs={[{ label: 'Org', to: '/org' }, { label: 'HR', to: '/hr' }, { label: 'Devices' }]}
      />
      <div className="card mb-4 flex flex-wrap gap-3 p-4">
        <Input placeholder="Device name" value={name} onChange={(e) => setName(e.target.value)} />
        <Input placeholder="Device code" value={code} onChange={(e) => setCode(e.target.value)} />
        <Select
          className="min-w-[10rem]"
          value={type}
          onChange={(v) => setType(v)}
          options={[
            { value: 'BIOMETRIC', label: 'Biometric' },
            { value: 'RFID', label: 'RFID' },
            { value: 'QR', label: 'QR' },
            { value: 'FACE', label: 'Face' },
          ]}
        />
        <Button onClick={register}>Register device</Button>
      </div>
      <ul className="space-y-2 text-sm">
        {devices.map((d) => (
          <li key={d.id} className="card p-3">
            {d.deviceName} ({d.deviceType}) — {d.deviceCode} {d.location ? `@ ${d.location}` : ''}
          </li>
        ))}
      </ul>
    </div>
  );
}
